<template>
  <div class="content" :class="{ content1: list.length == 0 }">
    <van-cell class="cell" v-for="item in list" :key="item.id">
      <template #title>
        <div class="item item-time">
          <span class="item-title item-time-title"
            >投保时间：{{ item.createTime }}</span
          >
          <span class="status">{{ statusList[item.policyStatus - 1] }}</span>
        </div>
        <div class="bx-name">{{ item.productName }}</div>
        <div class="item name">
          <span class="item-title">被投保人：</span>
          <span class="item-content">{{ item.insuranceName }}</span>
        </div>
        <div class="item">
          <span class="item-title">保障期限：</span>
          <span class="item-content"
            >{{ item.startTime }}至{{ item.endTime }}</span
          >
        </div>
        <div class="btn-box">
          <button @click="application(item)">申请理赔</button>
        </div>
      </template>
    </van-cell>
    <div class="no-data-box" v-if="list.length == 0">
      <img
        class="no-data"
        src="../../static/images/applyInfo/no-data.png"
        alt=""
      />
      <div class="no-data-text">暂无有效保单</div>
    </div>
  </div>
</template>


<script>
import { loading } from "@/api/mixins";
export default {
  mixins: [loading],
  data() {
    return {
      list: [],
      statusList: ["保障中", "续费", "退保", "终止", "失效"],
    };
  },
  created() {
    this.loading = true;
    this.getInfo();
  },
  mounted() {
    this.$weixin.hideMenu();
  },
  methods: {
    getInfo() {
      this.loading = true;
      this.$http({
        type: "PUT",
        url: "/api/compensation/getCanCompensatioPolicy",
        // url: "/api/compensation/bplat/getCanCompensatioPolicy",
        data: {
          plat: "bplat",
          mechanCode: this.$route.query.code,
        },
      })
        .then((res) => {
          this.loading = false;
          this.list = res.data;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    application(item) {
      //理赔申请
      this.$router.push({
        name: "applyInfo.claimApplication",
        query: { 
          policyNo: item.policyNo,
          plat: item.plat,
        },
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.content {
  position: relative;
  background: #f5f7fa;
  padding: 20px 30px 0;
  .item {
    display: flex;
    .item-title {
      font-weight: 400;
      font-size: 28px;
      color: #888888;
    }
    .item-content {
      font-size: 28px;
      font-weight: 400;
      color: #3c464f;
    }
  }
  .item-time {
    height: 70px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    .item-time-title {
      font-size: 24px;
    }
    .status {
      font-size: 28px;
      font-weight: 400;
      color: #236dff;
      opacity: 1;
    }
  }
  .bx-name {
    font-size: 32px;
    font-weight: 500;
    color: #3c464f;
    margin: 20px 0;
  }
  .name {
    margin-bottom: 10px;
  }
  .btn-box {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    button {
      width: 180px;
      height: 60px;
      line-height: 60px;
      border: none;
      outline: none;
      background: #236dff;
      opacity: 1;
      border-radius: 44px;
      color: #fff;
      font-size: 26px;
    }
  }
}
.content1 {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 0;
  background-color: #fff;
}
.no-data-box {
  background-color: #fff;
  padding-top: 140px;
  img {
    display: block;
    width: 490px;
    height: 282px;
    margin: 0 auto;
  }
}
.no-data-text {
  text-align: center;
  margin-top: 20px;
  color: #727c8e;
  font-size: 30px;
  font-weight: 400;
}
/deep/ .cell {
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 10px;
  padding: 0 30px 25px;
}
</style>
